import { H3 } from "@/components/Headers/Headings";
import { useDateFormatter } from "@/contexts/Translation";
import styles from "./AnnouncementItem.module.css";

type AnnouncementItemProps = {
  title: string;
  body: string;
  publishedAt: string;
};

const AnnouncementItem = ({ title, body, publishedAt }: AnnouncementItemProps) => {
  const d = useDateFormatter();

  return (
    <article className={styles.item}>
      <H3>{title}</H3>
      <div className={styles.date}>{d(publishedAt)}</div>
      <div className={styles.body}>{body}</div>
    </article>
  );
};

export default AnnouncementItem;
